import { PetsState, SetPetsAction } from "../types";
import { SET_PETS } from "../actions/pets";

export const pets = (state: PetsState, action: SetPetsAction): PetsState => {
  switch (action.type) {
    case SET_PETS:
      return action.pets;

    default:
      return state;
  }
};
